import { render } from "./NotFoundsView.vue?vue&type=template&id=060c3952"
import script from "./NotFoundsView.vue?vue&type=script&lang=js"
export * from "./NotFoundsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__